import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import * as c from '../constant';
import * as actions from '../action';

function UpdateVeterinaryModal({
  history,
  data,
  getVeterinaryFeeList,
  veterinaryFeeList,
  updating,
  updateVeterinaryFee,
  id,
  getSingleNewBusinesses,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    veterinary_fee_id: '',
  });

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getVeterinaryFeeList();
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      veterinary_fee_id: _.get(formData, 'veterinary_fee_id'),
    };

    return updateVeterinaryFee(id, args, () => {
      setModal({ isOpen: false });
      history.push(`/bpls/new-business/new-businesses/${id}`);
      getSingleNewBusinesses(id);
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const OnSetFormData = () => {
    setFormData({
      veterinary_fee_id: _.get(data, 'attributes.veterinary_fee_id') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(formData)) {
      OnSetFormData();
    }
  }, []);

  const listOption =
    veterinaryFeeList.map(item => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Veterinary Fee :
            </label>
            <Select
              options={vetRegistrationListOption}
              placeholder="Select Veterinary Fee"
              onChange={handleOnChangeSelect('veterinary_fee_id')}
              value={
                vetRegistrationListOption.find(item => {
                  return (
                    `${_.get(formData, 'veterinary_fee_id')}` ===
                    _.get(item, 'value')
                  );
                }) || ''
              }
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
UpdateVeterinaryModal.defaultProps = {
  data: {},
  id: '',
};

UpdateVeterinaryModal.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object),
  getVeterinaryFeeList: PropTypes.instanceOf(Function).isRequired,
  veterinaryFeeList: PropTypes.instanceOf(Array).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  updateVeterinaryFee: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  veterinaryFeeList: _.get(api, `${c.GET_VETERINARY_FEE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_VETERINARY_FEE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateVeterinaryModal);
